import React, { Component } from "react";
import { withRouter } from "react-router-dom";
import { withStyles } from '@material-ui/core/styles';
import CssBaseline from "@material-ui/core/CssBaseline";
import Input from '@material-ui/core/Input';
import FormHelperText from '@material-ui/core/FormHelperText';
import FormControl from "@material-ui/core/FormControl";
import OutlinedInput from "@material-ui/core/OutlinedInput";
import Select from "@material-ui/core/Select";
import Button from '@material-ui/core/Button';
import MenuItem from '@material-ui/core/MenuItem';
import Typography from "@material-ui/core/Typography";
import Grid from "@material-ui/core/Grid";
import Paper from "@material-ui/core/Paper";
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import DataUsageIcon from '@material-ui/icons/DataUsage';
import InputLabel from "@material-ui/core/InputLabel";

import Topbar from "./Topbar";

import { AuthContext } from "../context/auth";

import LocoDrone from "../libraries/LocoDrone";
import LocoDroneT from "../libraries/LocoDroneT";
import LocoDroneTT from "../libraries/LocoDroneTT";
import LocoIoT from "../libraries/LocoIoT";
import LocoArm from "../libraries/LocoArm";
import LocoArmM from "../libraries/LocoArmM";
import LocoWear from "../libraries/LocoWear";
import { LocoXtreme } from "../libraries/LocoXtreme";

import DataVisLW from "../components/drawers/DataVisLW";
import DataVisLD from "../components/drawers/DataVisLD";
import DataVisLDPrompt from "../components/drawers/DataVisLDPrompt";
import LXSettingsModal from './modals/LXSettingsModal';

import GeneralMessage from "./drawers/GeneralMessage"
import LDTSettingsModal from "./modals/LDTSettingsModal";
import LDTMatrix from "./LDTMatrix";
import LDTRGB from "./LDTRGB";
//import { webserial_disconnect } from "../webserial/webserial";
import { bleDeviceLS, LS_SENSOR_REJECT_VALUE, STATUS_SUCCESS, VERSION_FAILURE } from "../libraries/LocoScoutStore";
import LCInputsModal from "./modals/LCInputsModal";
import { MODAL_TYPE } from './modals/ButtonsListModal';
import ButtonsListModal from './modals/ButtonsListModal';

// Material-UI CSS-type Style Specifications
const styles = (theme) => ({
    root: {
        flexGrow: 1,
        backgroundColor: "white",
    },
    formControl: {
        width: "95%",
        justify: "center",
        margin: theme.spacing(0),
    },
    inputField: {
        width: "90%",
        marginLeft: theme.spacing(2),
    },
    inputHelper: {
        marginLeft: theme.spacing(4),
    },
    grid: {        
        flexGrow: 1,
        margin: theme.spacing(4),
    },
    paper: {
        flexGrow: 1,
        padding: theme.spacing(1),
        textAlign: "center",
        justify: "center",
        color: theme.palette.primary,
        backgroundColor: theme.palette.primary["light"],
        height: theme.spacing(42),
        width: theme.spacing(52),
    },
    actionButton: {
        justify: "center",
        margin: theme.spacing(1),
        color: theme.palette.primary["contrastText"],
        backgroundColor: "green",
        borderRadius: '25px',
    },
    input: {
        justify: "center",
        margin: theme.spacing(2),
        color: theme.palette.primary["contrastText"],
        backgroundColor: theme.palette.primary["light"],
    },
    title: {
        color: theme.palette.primary["contrastText"],
        backgroundColor: theme.palette.primary["light"],
    },
    media: {
        height: 0,
        paddingTop: '30%', // 
        marginTop:'30',
    },
    inline: {
      display: "inline"
    },
    buttonProgress: {
      color: "white",
      position: 'absolute',
      top: '50%',
      left: '50%',
      marginTop: 40,
      marginLeft: -12,
    },
    card: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        padding: theme.spacing(2),
        height: 150, // Set the height of the card
        maxWidth: 500, // Set a maximum width for the cards
        margin: 'auto', // Center the cards horizontally
        borderRadius: '10px',
    },
    cardLeft: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        padding: theme.spacing(2),
        height: 150, // Set the height of the card
        maxWidth: 500, // Set a maximum width for the cards
        margin: 'auto', // Center the cards horizontally
        borderRadius: '10px',
        transition: 'transform 0.3s, box-shadow 0.3s', // Add transition for smooth hover effect
        '&:hover': {
            transform: 'scale(1.05)', // Slightly scale up the card on hover
            boxShadow: theme.shadows[6], // Add a shadow effect on hover
        },
    },
    cardCenter: {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        padding: theme.spacing(2),
        height: '50%', // Set the height of the card
        maxWidth: 500, // Set a maximum width for the cards
        margin: 'auto', // Center the cards horizontally
        borderRadius: '10px',
        transform: 'translateY(-25%)', // Offset items slightly above center
        transition: 'transform 0.3s, box-shadow 0.3s', // Add transition for smooth hover effect
        '&:hover': {
            transform: 'translateY(-25%) scale(1.05)', // Slightly scale up the card on hover
            boxShadow: theme.shadows[6], // Add a shadow effect on hover
        },
    },
    icon: {
        fontSize: 40,
        marginBottom: theme.spacing(1),
        transition: 'transform 0.3s', // Add transition for smooth rotation
        '&:hover': {
            transform: 'rotate(360deg)', // Rotate the icon on hover
        },
    },
    formControlSelect: {
        justify: "center",
        margin: theme.spacing(1),
    },
    gridSelect: {
        //marginTop: theme.spacing(4),
        background: `linear-gradient(45deg, ${theme.palette.secondary.redLighter} 30%, ${theme.palette.secondary.redLighter} 90%)`,
        padding: theme.spacing(2),
        borderRadius: theme.shape.borderRadius,
        height: '100%', // Take up the full height of the parent
        display: 'flex',
        flexDirection: 'row', // Ensure the cards stay in the same row
        alignItems: 'center', // items vertically
        justifyContent: 'flex-start', // Align items to the start
    },
    select: {
        width: 175,
        //'&:hover': {
        //    backgroundColor: theme.palette.secondary.redLighter,
        //},
        transition: 'border-width 0.2s', // Add transition for smooth effects
        '&:hover .MuiOutlinedInput-notchedOutline': {
            borderColor: theme.palette.secondary.redLighter,
            borderWidth: '4px', // Change border thickness on hover
        }
    },
    menuItem: {
        '&:hover': {
            backgroundColor: theme.palette.secondary.redLighter,
        },
    }
  });



const hSelectSendValue = ['LocoDrone', 'LocoArm', 'LocoArmS', 'LocoArmM', 'LocoArmMS'];
const hSelectSendRefer = ['LocoScout', 'LocoCraze', 'LocoDroneC', 'LocoRover', 'LocoHex'];


// Component Class - Data Vis
class DataVis extends Component {

    static contextType = AuthContext;

    constructor(props, context) {

        super(props, context);

        this.visLWElement = React.createRef();
        this.visLDElement = React.createRef();
        this.visLDPromptElement = React.createRef();
        //
        this.LXSelectionElement = React.createRef();
        this.LXScanMsgElement = React.createRef();
        this.LXConnMsgElement = React.createRef();
        this.LXNoConnMsgElement = React.createRef();

        this.LXConnError = false;

        this.LDTSelectionElement = React.createRef();
        this.LDTScanMsgElement = React.createRef();
        this.LDTConnMsgElement = React.createRef();
        this.LDTNoConnMsgElement = React.createRef();
        this.MsgElement = React.createRef();
        this.ButtonsListElem = React.createRef();

        this.matrixElement = React.createRef();
        this.rgbElement = React.createRef();

        this.LCInputsElement = React.createRef();

        this.charRef0 = React.createRef();
        this.charRef1 = React.createRef();
        this.charRef2 = React.createRef();

        this.skip_count = 0;
        this.skip_LIMIT = 4;

        this.testObj = null;
    }

    // Class state
    state = {
        userAccessIndx: 1,
        hardwareSelection: this.context.AuthInstance.userAccess[1],
        LRobj: null,
        selected: false,
        colorSelection: 'red',
        colorOptions: ['red', 'green', 'blue'], 
        colorCodes: {red:'rgb(200, 0, 0)', green:'rgb(0, 200, 0)', blue:'rgb(0, 0, 200)'},
        sensorSelection: '',
        bufferSize: 100,
        bufferMin: 10,
        bufferMax: 100,
        updateRate: 250,
        plottingText: "Start Plotting",
        isPlotting: false,
        isConnected: false,
        connectText: "Connect",
        isIoT: false,
        updateID: null,
        extraID: null,
        iotIsSetup: false,
        message_str_1: "",
    }


    componentDidMount() {
    };

    componentWillUnmount() {
        if (this.state.hardwareSelection === 'LocoDroneT') {
            this.disconnectDroneTView().catch(err => console.error('Drone view cleanup failed:', err));
            return;
        }
        try {
            if (this.state.isPlotting === true) {
                this.setState( {isPlotting: false} );
                clearTimeout(this.state.updateID);
            }
            if (this.state.isConnected === true) {
                if (this.state.hardwareSelection === 'LocoXtreme') {
                    try {
                        this.state.LRobj.reset_ble().then(() => {
                            this.state.LRobj.disconnect();
                        });
                    } catch {}
                } else {
                    try {
                        this.state.LRobj.disconnect();
                    } catch {}
                }
                this.setState( {isConnected: false} );
            }
        } catch {}
    };

    handleChange = event => {
        this.setState( {[event.target.name]: event.target.value} );
    };
    
    handleChangeBuffer = event => {
        this.setState( {bufferSize: event.target.value} );
    };

    handleBack = async () => {
        if (this.state.hardwareSelection === 'LocoDroneT') {
            await this.disconnectDroneTView();
            this.setState({ selected: false, isIoT: false, iotIsSetup: false,
                isConnected: false, connectText: 'Connect', isPlotting: false, plottingText: 'Start Plotting' });
            return;
        }
        if (this.state.isPlotting === true) {
            this.setState( {isPlotting: false, plottingText: "Start Plotting"} );
            clearTimeout(this.state.updateID);
        }
        if (this.state.isConnected === true) {
            try {
                this.state.LRobj.disconnect();
            } catch {}
            this.setState( {isConnected: false, connectText: "Connect"} );
        }
        this.setState( {selected: false, isIoT: false} );
        this.setState( {iotIsSetup: false} );
    }


    stopDroneTCallbacks = () => {
        this._ldtTelemetryGeneration = (this._ldtTelemetryGeneration || 0) + 1;
        this._ldtTelemetryPaused = true;
        clearTimeout(this._ldtMonitorTimer);
        clearTimeout(this.state.updateID);
        const owner = this.state.LRobj;
        if (owner) clearTimeout(owner.get_vitals_timer_ID());
    }

    toggleDroneTPlotting = async () => {
        if (this._ldtPlotToggleBusy) return;
        this._ldtPlotToggleBusy = true;
        const owner = this.state.LRobj;
        const stopping = this.state.isPlotting;
        this.stopDroneTCallbacks();
        const generation = this._ldtTelemetryGeneration;
        try {
            // Let outstanding telemetry finish; do not cancel its response timeout.
            await Promise.all([this._ldtMonitorPromise, this._ldtPlotReadPromise]);
            if (generation !== this._ldtTelemetryGeneration ||
                !owner.serialSession || owner.serialSession.status !== 'open' || owner.serialSession.closing) return;
            owner.resetArrays();
            if (stopping) {
                await new Promise(resolve => this.setState({ isPlotting: false, plottingText: 'Start Plotting' }, resolve));
                if (generation !== this._ldtTelemetryGeneration || owner.serialSession.status !== 'open' || owner.serialSession.closing) return;
                this._ldtTelemetryPaused = false;
                this._ldtMonitorTimer = setTimeout(this.ldt_monitor, owner.VITALS_MONITOR_TIME_A);
                owner.set_vitals_timer_ID(this._ldtMonitorTimer);
            } else {
                const bufferSize = Math.min(Math.max(this.state.bufferSize, this.state.bufferMin), this.state.bufferMax);
                owner.set_buffer_size(bufferSize);
                await new Promise(resolve => this.setState({ bufferSize: owner.get_buffer_size(), isPlotting: true, plottingText: 'Stop Plotting' }, resolve));
                if (generation !== this._ldtTelemetryGeneration || owner.serialSession.status !== 'open' || owner.serialSession.closing) return;
                this._ldtTelemetryPaused = false;
                const updateID = setTimeout(this.createPlots, 500);
                this.setState({ updateID });
            }
        } finally { this._ldtPlotToggleBusy = false; }
    }

    monitorDroneT = async () => {
        if (this._ldtTelemetryPaused || !this.state.isConnected) return 0;
        if (this._ldtMonitorPromise) return this._ldtMonitorPromise;
        const owner = this.state.LRobj;
        const generation = this._ldtTelemetryGeneration;
        const current = () => !this._ldtTelemetryPaused && generation === this._ldtTelemetryGeneration &&
            owner === this.state.LRobj && this.state.isConnected && owner.serialSession &&
            owner.serialSession.status === 'open' && !owner.serialSession.closing;
        if (!current()) return 0;
        this._ldtMonitorPromise = (async () => {
            try {
                if (await owner.drone_get_data('DATA_BATTERY') === 'failure' || !current()) return 0;
                if (await owner.drone_get_data('DATA_TEMP') === 'failure' || !current()) return 0;
                this.setState({ message_str_1: 'Battery Level (%) ' + owner.battery_last + ',  Temperature (C): ' + owner.temperature_last });
                if (!this.state.isPlotting) {
                    this._ldtMonitorTimer = setTimeout(this.ldt_monitor, owner.VITALS_MONITOR_TIME_A);
                    owner.set_vitals_timer_ID(this._ldtMonitorTimer);
                }
                return 1;
            } catch (err) {
                // Intentional stop/disconnect invalidates this callback before closing.
                if (current() && this.LDTSelectionElement.current) this.LDTSelectionElement.current.handleMessage(err.message || 'Drone telemetry failed.', 4000);
                return 0;
            }
        })();
        try { return await this._ldtMonitorPromise; }
        finally { this._ldtMonitorPromise = null; }
    }

    getDroneTPlotData = async () => {
        const owner = this.state.LRobj;
        const generation = this._ldtTelemetryGeneration;
        this._ldtPlotReadPromise = (async () => {
            try {
                if (await this.monitorDroneT() === 0 || this._ldtTelemetryPaused || generation !== this._ldtTelemetryGeneration) return 0;
                const result = await owner.drone_get_data(owner.self[owner.options[this.state.sensorSelection].refer].value);
                return result === 'failure' ? 0 : 1;
            } catch (err) {
                if (!this._ldtTelemetryPaused && generation === this._ldtTelemetryGeneration && this.LDTSelectionElement.current) {
                    this.LDTSelectionElement.current.handleMessage(err.message || 'Drone telemetry failed.', 4000);
                }
                return 0;
            }
        })();
        try { return await this._ldtPlotReadPromise; }
        finally { this._ldtPlotReadPromise = null; }
    }

    disconnectDroneTView = async () => {
        this.stopDroneTCallbacks();
        this._ldtViewSession = (this._ldtViewSession || 0) + 1;
        clearTimeout(this._ldtPostConnectTimer);
        if (this.LDTConnMsgElement.current) this.LDTConnMsgElement.current.handleClose();
        if (this.LDTScanMsgElement.current) this.LDTScanMsgElement.current.handleClose();
        clearTimeout(this.state.updateID);
        const owner = this.state.LRobj;
        if (!owner) return;
        // Stop and join the original owner before clearing or replacing it.
        await owner.disconnect();
        await Promise.all([this._ldtMonitorPromise, this._ldtPlotReadPromise]);
        owner.clearLDTTimeouts();
        clearTimeout(owner.get_vitals_timer_ID());
        owner.clearData();
    }

    handleDroneTConnect = async () => {
        if (this._ldtBusy) return;
        this._ldtBusy = true;
        const owner = this.state.LRobj;
        const session = this._ldtViewSession = (this._ldtViewSession || 0) + 1;
        try {
            if (this.state.isConnected) {
                await this.disconnectDroneTView();
                this.setState({ LRobj: new LocoDroneT(), isConnected: false, connectText: 'Connect',
                    isPlotting: false, plottingText: 'Start Plotting' });
                return;
            }
            this.LDTConnMsgElement.current.handleOpenStay('blue', 'Connecting...');
            const result = await owner.connect();
            await new Promise(resolve => setTimeout(resolve, 1000));
            if (session !== this._ldtViewSession) return;
            if (result !== 'done') throw new Error('Could not open the drone serial connection.');
            this._ldtTelemetryPaused = false;
            this.setState({ connectText: 'Connecting...' });
            await this.postConnectLDT();
        } catch (err) {
            if (session === this._ldtViewSession && this.LDTSelectionElement.current) {
                this.LDTSelectionElement.current.handleMessage(err.message || 'Drone connection failed.', 4000);
            }
        } finally {
            this._ldtBusy = false;
            if (session === this._ldtViewSession && this.LDTConnMsgElement.current) this.LDTConnMsgElement.current.handleClose();
        }
    }

    handleConnect = async () => {
        if (this.state.hardwareSelection === 'LocoDroneT') return this.handleDroneTConnect();

        if (this.state.isConnected === false ) {
            if (this.state.hardwareSelection === 'LocoXtreme') {
                this.LXConnMsgElement.current.handleOpenStay('blue', 'Connecting...');
            }
            else if ((this.state.hardwareSelection === 'LocoDroneT') || 
            (this.state.hardwareSelection === 'LocoDroneTT')) {
                this.LDTConnMsgElement.current.handleOpenStay('blue', 'Connecting...');
            }
            else if (this.state.hardwareSelection === 'LocoScout') {
                this.MsgElement.current.handleOpenStay('blue', 'Connecting...', 1000);
            }
            else if (this.state.hardwareSelection === 'LocoCraze') {
                this.LCInputsElement.current.handleOpen(this.context.AuthInstance);
                return;
            } else if (this.context.AuthInstance.LR_OVERLAPS.includes(this.state.hardwareSelection)) {
                this.MsgElement.current.handleOpenStay('blue', 'Connecting...', 1000);
            }

            return this.state.LRobj.connect().then((res) => {
                if ((this.state.hardwareSelection !== 'LocoXtreme') && 
                    (this.state.hardwareSelection !== 'LocoDroneT') &&
                    (this.state.hardwareSelection !== 'LocoDroneTT') && 
                    (this.state.hardwareSelection !== 'LocoScout') && 
                    (this.state.hardwareSelection !== 'LocoCraze') &&
                    (!this.context.AuthInstance.LR_OVERLAPS.includes(this.state.hardwareSelection))
                ) {
                    this.setState( {isConnected: true, connectText: "Disconnect"} );
                } else if (this.state.hardwareSelection === 'LocoScout') {
                    if (res === STATUS_SUCCESS) {
                        //this.MsgElement.current.handleClose();
                        this.state.LRobj.setData('kup').then(() => {
                            if (res === STATUS_SUCCESS) {
                                if (!this.state.LRobj.version.includes(this.state.LRobj.BV0)) {
                                    this.state.LRobj.getBattery().then((value) => {
                                        if (value === LS_SENSOR_REJECT_VALUE) {
                                            this.MsgElement.current.handleOpen(
                                                'blue', 
                                                'Battery Level: Invalid', 
                                                2000
                                            );
                                        } else {
                                            this.MsgElement.current.handleOpen(
                                                'blue', 
                                                'Battery Level ' + value + ' V', 
                                                2000
                                            );
                                        }
                                        if (!this.state.LRobj.version.includes(this.state.LRobj.B)) {
                                            // set gyro toggle
                                            this.state.LRobj.setData('G').then(() => {
                                                this.setState( {isConnected: true, connectText: "Disconnect"} );
                                            });
                                        } else {
                                            this.state.LRobj.disableGyro().then(() => {
                                                this.setState( {isConnected: true, connectText: "Disconnect"} );
                                            });
                                        }
                                    });
                                } else {
                                    this.state.LRobj.disableGyro().then(() => {
                                        this.MsgElement.current.handleClose();
                                        this.setState( {isConnected: true, connectText: "Disconnect"} );
                                    });
                                }
                            }
                        });
                    } else if (res === VERSION_FAILURE) {
                        this.MsgElement.current.handleOpen(
                            'red', 
                            'Incompatible Firmware Version', 
                            3000
                        );
                        this.state.LRobj.disconnect().then(() => {
                            this.setState( {isConnected: false, connectText: "Connect"} );
                        })
                    } else {
                        this.MsgElement.current.handleOpen(
                            'red', 
                            'Connection Failed, Please Try Again', 
                            4000
                        );
                    }
                } else {
                    this.setState( {connectText: "Connecting..."} );
                }
                if (this.state.hardwareSelection === 'LocoDrone') {
                    this.state.LRobj.send_command(98);
                    //this.visLDElement.current.handleOpen();
                    this.visLDPromptElement.current.handleOpen();
                } else if (this.state.hardwareSelection === 'LocoWear') {
                    setTimeout(this.postConnect, 1000);
                } else if (this.state.hardwareSelection === 'LocoXtreme') {
                    setTimeout(this.postConnectLX, 250);//100);
                } else if ((this.state.hardwareSelection === 'LocoDroneT') ||
                            (this.state.hardwareSelection === 'LocoDroneTT')) {
                    setTimeout(this.postConnectLDT, 250);//100);
                } else if (this.context.AuthInstance.LR_OVERLAPS.includes(this.state.hardwareSelection)) {
                    setTimeout(this.postConnectOverlaps, 250);//100);
                }
            }).catch((err) => {
                console.log(err);
            });
        } else {
            if (this.state.hardwareSelection === 'LocoWear') {
                this.state.LRobj.self.bound = false;
            } else if ((this.state.hardwareSelection === 'LocoDroneT') || 
                        (this.state.hardwareSelection === 'LocoDroneTT')) {
                this.state.LRobj.clearLDTTimeouts()
                this.state.LRobj.clearData()
                clearTimeout(this.state.LRobj.get_vitals_timer_ID);
                if (this.state.hardwareSelection === 'LocoDroneT') {
                    let tempObj = new LocoDroneT();
                    this.setState( {LRobj: tempObj} );
                } else if (this.state.hardwareSelection === 'LocoDroneTT') {
                    let tempObj = new LocoDroneTT();
                    this.setState( {LRobj: tempObj} );
                }
            } else if (this.state.hardwareSelection === 'LocoScout') {
                this.state.LRobj.clearWaiting();
                try {
                    await this.state.LRobj.setData('d');
                } catch {
                    try {
                        await this.state.LRobj.disconnect();
                    } catch {}
                }
            }
            this.setState( {isPlotting: false, plottingText: "Start Plotting", isConnected: false} );
            this.state.LRobj.resetArrays();
           

            setTimeout( this.changeConnect, 50);
        }
    }

    postConnect = () => {
        this.state.LRobj.send_command(99);
        this.state.LRobj.send_command(98);
        this.visLWElement.current.handleUpdateMsgLooking();
        setTimeout(this.checkForBind, 100);
    }

    postConnectOverlaps = async () => {
        
        this.MsgElement.current.handleClose();
        // update this

        if (window.shared[this.state.hardwareSelection + 'Obj'].port == null) {
            this.setState({ isConnected: false, connectText: "Connect" });
            return;
        }
        
        this.MsgElement.current.handleOpenStay('green', 'Scanning...')
        this.state.LRobj.wifi_scan().then((res) => {
            this.MsgElement.current.handleClose();
            if (res === "timeout") {
                let msgStr = 'Error Completing Scan, Please Try Again. If The Problem Persists, Reset Your Controller.'
                //this.MsgElement.current.handleMessage(msgStr, 4000)
                this.MsgElement.current.handleOpen("red", msgStr, 4000);
                this.state.LRobj.disconnect();
                this.setState( {isConnected: false, connectText: "Connect"} );
            } else {
                
                this.ButtonsListElem.current.handleOpen(
                    this.state.hardwareSelection,
                    MODAL_TYPE.PICK,
                    this.state.LRobj.robotData['scanData']    
                )

            }
        });



    }

    ButtonsListSelection = async(name_str) => {
        if (name_str !== '') {
            this.MsgElement.current.handleOpenStay('green', 'Connecting...');
            this.state.LRobj.connect_wifi(name_str).then((res) => {
                if (res === true) {
                    if (this.state.sensorSelection >= this.state.LRobj.optionNames.length) {
                        this.setState( {sensorSelection: this.state.LRobj.optionNames[0]} );    
                    }
                }
                this.MsgElement.current.handleClose();
                this.setState( {isConnected: true, connectText: "Disconnect"} );
            }).catch((err) => {
                this.MsgElement.current.handleOpen('red', 'Could Not Connect To Robot, Please Try Again', 1000);
                this.setState( {isConnected: false, connectText: "Connect"} );
            });
        } else {
            this.MsgElement.current.handleClose();
            await this.state.LRobj.disconnect();
            this.setState( {isConnected: false, connectText: "Connect"} );
        }

    }

    LCConnect = async () => {

        //this.context.AuthInstance.loadedState.LocoCraze

        this.MsgElement.current.handleOpenStay('blue', 'Connecting...');

        const hexAddr = this.context.AuthInstance.loadedState.LocoCraze.address;
        const channel = this.context.AuthInstance.loadedState.LocoCraze.channel;
        return this.state.LRobj.connect(hexAddr, channel).then((res) => {
            if (res) {
                this.MsgElement.current.handleClose();
                this.setState( {isConnected: true, connectText: "Disconnect"} );
            } else {
                this.MsgElement.current.handleOpen('red', 'Connection Failed', 3000);
                this.state.LRobj.disconnect().then(() => {
                    this.setState( {isConnected: false, connectText: "Connect"} );
                }) 
            }
        }).catch((err) => {
            this.MsgElement.current.handleOpen('red', 'Connection Failed', 3000);
        });
    };


    postConnectLX = () => {
        
        this.LXConnMsgElement.current.handleClose();
        if (!window.serialport) {
            this.setState( {isConnected: false, connectText: "Connect"} );
            return
        }

        const SCAN_TIME = 4000;
        const SCAN_MSG_TIME = 5000;
        this.LXScanMsgElement.current.handleOpen('green', 'Scanning...', SCAN_MSG_TIME)
        this.state.LRobj.scan_start(SCAN_TIME).catch(err => console.error('Scan start failed:', err));
    }

    postConnectLDT = async () => {
        const owner = this.state.LRobj;
        const viewSession = this._ldtViewSession;
        const current = () => this.state.hardwareSelection !== 'LocoDroneT' ||
            (viewSession === this._ldtViewSession && owner === this.state.LRobj);
        this.LDTConnMsgElement.current.handleClose();
        if (!window.serialport) {
            this.setState({ isConnected: false, connectText: "Connect" });
            return;
        }

        let completed = false;
        this.LDTScanMsgElement.current.handleOpenStay('green', 'Scanning...');
        try {
            const result = await owner.drone_scan();
            if (!current()) return;
            completed = result !== 'timeout';
            // Retain compatibility with libraries that return a timeout sentinel.
            if (result === "timeout") {
                this.LDTSelectionElement.current.handleMessage(
                    'Error Completing Scan, Please Try Again. If The Problem Persists, Reset Your Controller.',
                    4000
                );
            }
        } catch (err) {
            if (!current()) return;
            this.LDTSelectionElement.current.handleMessage(
                err.message || 'Drone scan failed. Please try again.', 4000
            );
        } finally {
            if (current() && this.LDTScanMsgElement.current) this.LDTScanMsgElement.current.handleClose();
        }
        if (completed && current() && this.state.hardwareSelection === 'LocoDroneT') {
            this.openLDTSelection();
        }
    }

    LXSelection = async (r_event) => {
                
        //this.setState( {lxselected: r_event, lxwaiting: false} );
        let targetIndex = -1;
        for (let i = 0; i < this.state.LRobj.robots.length; i++) {
            if (this.state.LRobj.robots[i]['name'] === r_event) {
                targetIndex = i
                break
            }
        }
        
        if (targetIndex !== -1) {
            this.state.LRobj.connect_ble(targetIndex).then(() => {
                this.setState( {isConnected: true, connectText: "Disconnect"} );
            }).catch((err) => {
                this.LXNoConnMsgElement.current.handleOpen('red', 'Could Not Connect To Robot, Please Try Again', 1000);
                this.setState( {isConnected: false, connectText: "Connect"} );
                try {
                    this.state.LRobj.scan_start(100).then(() => {
                        setTimeout(this.tryLXClear, 200);
                    }).catch(err => console.error('Scan start failed:', err));
                } catch {}
            });

        } else {
            await this.state.LRobj.disconnect();
            this.setState( {isConnected: false, connectText: "Connect"} );
        }
    }

    LDTSelection = async (r_event) => {
        let targetIndex = -1
        for (let i = 0; i < this.state.LRobj.sharedData.drones['scanData'].length; i++) {
            if (this.state.LRobj.sharedData.drones['scanData'][i] === r_event) {
                targetIndex = i
                break
            }
        }
        if (targetIndex !== -1) {
            this.state.LRobj.connect_wifi(targetIndex).then((res) => {
                if (res === true) {
                    if (this.state.sensorSelection >= this.state.LRobj.optionNames.length) {
                        this.setState( {sensorSelection: this.state.LRobj.optionNames[0]} );    
                    }
                }
                this.setState( {isConnected: true, connectText: "Disconnect"} );
                this.skip_count = this.skip_LIMIT
                this.ldt_monitor()
            }).catch((err) => {
                this.LDTNoConnMsgElement.current.handleOpen('red', 'Could Not Connect To Drone, Please Try Again', 1000);
                this.setState( {isConnected: false, connectText: "Connect"} );
            });

        } else {
            if (this.state.hardwareSelection === 'LocoDroneT') {
                const owner = this.state.LRobj;
                try {
                    const session = owner.serialSession;
                    if (session && session.status === 'open' && !session.closing) {
                        await owner.disconnect_drone();
                    }
                } catch (err) {
                    console.error('Drone disconnect command failed:', err);
                } finally {
                    try { await this.disconnectDroneTView(); }
                    catch (err) { console.error('Drone connection cleanup failed:', err); }
                    this.setState({ isConnected: false, connectText: 'Connect' });
                }
                return;
            }
            await this.state.LRobj.disconnect_drone();
            await this.state.LRobj.disconnect();
            this.setState( {isConnected: false, connectText: "Connect"} );
        }
    }

    tryLXClear = () => {
        try {
            this.state.LRobj.reset_ble().then(() => {
                this.state.LRobj.disconnect().then(() => {
                    let tempObj = new LocoXtreme();
                    this.setState( {LRobj: tempObj} );
                });
            });          
        } catch {}
    }

    openLXSelection = () => {
        
        this.LXSelectionElement.current.handleOpen("PICK", this.state.LRobj.robots);

    }

    
    handleLDTScanDrawerClose = () => {
        // For LocoDroneT, only successful scan completion opens selection.
        if (this.state.hardwareSelection !== 'LocoDroneT') this.openLDTSelection();
    }

    openLDTSelection = () => {
        if (this.state.hardwareSelection === 'LocoDroneT') {
            const session = this.state.LRobj && this.state.LRobj.serialSession;
            if (!session || session.status !== 'open' || session.closing) return;
        }
        this.LDTSelectionElement.current.handleOpen("PICK", this.state.LRobj.sharedData.drones['scanData']);

    }

    checkForBind = () => {

        if (this.state.LRobj.self.bound === true) {
            this.visLWElement.current.handleUpdateMsgFound();
        } else {
            setTimeout(this.checkForBind, 100);
        }
    }

    changeConnect = async () => {
        if (this.state.hardwareSelection === 'LocoDroneT') {
            await this.disconnectDroneTView();
            this.setState({ isConnected: false, connectText: 'Connect' });
            return;
        }
        try {            
            if (this.state.hardwareSelection === 'LocoXtreme') {
                this.state.LRobj.reset_ble().then(() => {
                    this.state.LRobj.disconnect();
                });
            } else if (this.state.hardwareSelection === 'LocoScout') { 
                await this.state.LRobj.disconnect();
            } else {
                this.state.LRobj.disconnect();
                this.setState( {iotIsSetup: false} );
            }
            this.setState( {isConnected: false, connectText: "Connect"} );
        } catch {
            try {
                this.setState( {isConnected: false, connectText: "Connect"} );
            } catch {}
        }
    }

    handleStartPlotting = async () => {
        if (this.state.hardwareSelection === 'LocoDroneT') return this.toggleDroneTPlotting();

        if (this.state.isPlotting === false) {

            if (this.state.hardwareSelection === 'LocoXtreme') {
                await this.state.LRobj.enable_sensor(this.state.LRobj.self[this.state.LRobj.options[this.state.sensorSelection]['refer']].value, 1)
            } else if ((this.state.hardwareSelection === 'LocoDroneT') || 
                (this.state.hardwareSelection === 'LocoDroneTT')) {
                clearTimeout(this.state.LRobj.get_vitals_timer_ID);
                this.state.LRobj.clearLDTTimeouts()
            } else if (this.state.hardwareSelection === 'LocoDroneC') {
                // reset gyro
                await window.shared.LocoDroneCObj.resetGyro();
            }

            let tempLRobj = this.state.LRobj;
            if (this.state.bufferSize > this.state.bufferMax) {
                tempLRobj.set_buffer_size(this.state.bufferMax);
            } else if (this.state.bufferSize < this.state.bufferMin) {
                tempLRobj.set_buffer_size(this.state.bufferMin);
            } else {
                tempLRobj.set_buffer_size(this.state.bufferSize);
            }
            this.setState( {LRobj: tempLRobj} );
            this.setState( {bufferSize: tempLRobj.get_buffer_size(), isPlotting: true, plottingText: "Stop Plotting"} );

            let timeoutID = setTimeout(this.createPlots, 500);
            this.setState( {updateID: timeoutID} );

        } else {
            clearTimeout(this.state.updateID);
            if (this.state.hardwareSelection === 'LocoXtreme') {          
                for (let i = 0; i < this.state.LRobj.options.length; i++) {
                    await this.state.LRobj.enable_sensor(this.state.LRobj.self[this.state.LRobj.options[this.state.sensorSelection]['refer']].value, 0)
                }
            } else if ((this.state.hardwareSelection === 'LocoDroneT') ||
                        (this.state.hardwareSelection === 'LocoDroneTT')) {
                //
                await this.state.LRobj.clearLDTTimeouts()
                await this.state.LRobj.clearData()
                clearTimeout(this.state.updateID);
                //
                let timeoutID = setTimeout(this.ldt_monitor, this.state.LRobj.VITALS_MONITOR_TIME_A);
                this.setState( {updateID: timeoutID} );
            }
            this.setState( {isPlotting: false, plottingText: "Start Plotting"} );
            this.state.LRobj.resetArrays();
        }

    };


    createPlots = async () => {
        const generation = this._ldtTelemetryGeneration;
        if (this.state.hardwareSelection === 'LocoDroneT' && (this._ldtTelemetryPaused || generation !== this._ldtTelemetryGeneration || !this.state.isPlotting)) return;

        let fontObj = {
            family: 'Courier New, monospace',
            size: 18,
            color: '#070707'
        };
        let marginObj = {
            t: 50, b: 50 
        };
        let heightVal = 300;
        let xLabelObj = { title: 'Sample (#)', };

        for (let i = 0; i < this.state.LRobj.options[this.state.sensorSelection].count; i++) {            
            let data = [{
                y: [0],
                type: 'scattergl',
                line: {color: this.state.colorCodes[this.state.colorSelection],},
                mode: 'lines',
            }];

            let layout = {
                xaxis: xLabelObj, 
                height: heightVal,
                margin: marginObj,
                mode: 'lines',
                font: fontObj,
                yaxis: { title: this.state.LRobj.self[this.state.LRobj.options[this.state.sensorSelection].refer].ylabels[i], } 
            };
            await window.Plotly.newPlot(this[`charRef${i}`].current, data, layout);
            if (this.state.hardwareSelection === 'LocoDroneT' && (this._ldtTelemetryPaused || generation !== this._ldtTelemetryGeneration || !this.state.isPlotting)) return;
            
            if (this.state.hardwareSelection === 'LocoIoT') {
                
                if ((this.state.sensorSelection === 'Accelerometer') || (this.state.sensorSelection === 'Gyroscope')) {
                    this.state.LRobj.send_enable( this.state.LRobj.IOT_Codes_Constants['SUBTYPE_MPU']);
                } else {
                    this.state.LRobj.send_enable( this.state.LRobj.IOT_Codes_Constants[this.state.LRobj.options[this.state.sensorSelection].refer]);
                }

                if (this.state.iotIsSetup === false) {
                    this.setupIoT();
                }
            }
            
            //let timeoutID = setTimeout(this.updatePlot, this.state.updateRate);
            //this.setState( {updateID: timeoutID} );
        }
        //if (typeof this.state.LRobj.options[this.state.sensorSelection].count === 'string' || this.state.LRobj.options[this.state.sensorSelection].count instanceof String) {
        let timeoutID = setTimeout(this.updatePlot, this.state.updateRate);
        this.setState( {updateID: timeoutID} );
        //}
    }

    setupIoT = () => {
        this.state.LRobj.send_start();
        this.setState( {iotIsSetup: true} );
    };

    ldt_monitor = async () => {
        if (this.state.hardwareSelection === 'LocoDroneT') return this.monitorDroneT();
        if (this.state.isConnected === true) {
            let msg = await this.state.LRobj.drone_monitor_vitals();
            if (msg.includes("NaN")) {
                let msgStr = 'Drone Communication Degraded, Please Charge Drone'
                this.LDTSelectionElement.current.handleMessage(msgStr, 3000)
                return 0
            }
            /*if (this.state.hardwareSelection === 'LocoDroneT') {
                let vitals_state = this.state.LRobj.drone_check_vitals();
                if (vitals_state === this.state.LRobj.VITALS_OK) {
                    this.setState( {message_str_1: msg} )
                    if (this.state.isPlotting === false) {
                        this.state.LRobj.set_vitals_timer_ID(setTimeout(this.ldt_monitor, this.state.LRobj.VITALS_MONITOR_TIME_A))
                    }
                }
            *///} else {
            this.setState( {message_str_1: msg} )
            if (this.state.isPlotting === false) {
                this.state.LRobj.set_vitals_timer_ID(setTimeout(this.ldt_monitor, this.state.LRobj.VITALS_MONITOR_TIME_A))
            }
            //}
            
            /*else {
                // close connection
                this.handleConnect()
                // drawer here
                this.LDTNoConnMsgElement.current.handleOpen('red', vitals_state, 3000);
                return 0
            }*/
        }
        return 1
    }

    getData = async () => {
        if (this.state.hardwareSelection === 'LocoDroneT') return this.getDroneTPlotData();

        if (hSelectSendValue.includes(this.state.hardwareSelection)) {
            await this.state.LRobj.send_command(
                this.state.LRobj.self[this.state.LRobj.options[this.state.sensorSelection].refer].value
            );
            return 1;
        } else if (hSelectSendRefer.includes(this.state.hardwareSelection)) {
            await this.state.LRobj.send_command(
                this.state.LRobj.self[this.state.LRobj.options[this.state.sensorSelection].refer]
            );
            return 1;
        } else if (this.state.hardwareSelection === 'LocoWear') {
            this.state.LRobj.send_command(this.state.LRobj.self.GET_DATA.value);
            return 1
        } else if (this.state.hardwareSelection === 'LocoIoT') {
            let data = null;
            if (this.state.sensorSelection === 'Accelerometer') {
                data = [1, 0];
                this.state.LRobj.send_request(this.state.LRobj.IOT_Codes_Constants.SUBTYPE_MPU, data);
            } else if (this.state.sensorSelection === 'Gyroscope') {
                data = [0, 1];
                this.state.LRobj.send_request(this.state.LRobj.IOT_Codes_Constants.SUBTYPE_MPU, data);
            } else {
                this.state.LRobj.send_request(this.state.LRobj.IOT_Codes_Constants[this.state.LRobj.options[this.state.sensorSelection].refer], data);
            }
            return 1
        } else if ((this.state.hardwareSelection === 'LocoDroneT') || 
                    (this.state.hardwareSelection === 'LocoDroneTT')) {
            try {
                const res = await this.ldt_monitor()
                if (res === 0) {
                    this.LDTNoConnMsgElement.current.handleOpen(
                        'red', 'Drone Communication Degraded, Please Charge Drone', 3000
                    );
                    return 0
                }
            } catch (err) {
            }

            //
            let read_state = await this.state.LRobj.drone_get_data(this.state.LRobj.self[this.state.LRobj.options[this.state.sensorSelection].refer].value)
            if (read_state === "timeout") {
                if (this.state.hardwareSelection === 'LocoDroneTT') {
                    let msgStr = 'Communication Issue Between The Drone and Controller.'
                    this.LDTSelectionElement.current.handleMessage(msgStr, 4000)
                }
                var me = this
                new Promise((resolve, reject) => {
                        me.extraID = setTimeout(() => {
                            resolve(1);
                        }, 4500);
                  }).then(() => {
                        return 1
                  });
            } else if (read_state === "failure") {
                let msgStr = 'Communication To The Drone Was Lost'
                this.LDTSelectionElement.current.handleMessage(msgStr, 4000)
                return 0
            } else {
                return 1
            }
        } else {
            return 1
        }
    };


    updatePlot = async () => {
        const generation = this._ldtTelemetryGeneration;
        if (this.state.hardwareSelection === 'LocoDroneT' && (this._ldtTelemetryPaused || generation !== this._ldtTelemetryGeneration || !this.state.isPlotting)) return;

        //console.log("here in update", this.state.isPlotting)
        if (this.state.isPlotting === true) {

            if (this.state.hardwareSelection === 'LocoDroneTT') {

                if (this.state.sensorSelection === 'Matrix') {
                    if (this.matrixElement.current.state.mouseIsPressed === false) {       
                        if (this.state.isPlotting === true) {
                            await this.state.LRobj.drone_tt_mled_set(this.matrixElement.current.gridData)
                        }
                    }
                    if (this.state.isPlotting === true) {
                        await this.ldt_monitor()
                    }

                    //
                    //this.skip_count += 1
                    //if (this.skip_count >= this.skip_LIMIT) {
                    //    this.skip_count = 0
                    //    let monitor_state = await this.ldt_monitor()
                        //if (monitor_state === 0) {
                        //    return 0
                        //}
                    //}

                    if (this.state.isPlotting === true) {
                        let timeoutID = setTimeout(this.updatePlot, this.state.updateRate);
                        this.setState( {updateID: timeoutID} );
                    }
                    return
                } else if (this.state.sensorSelection === 'RGB') {

                    
                    if (this.state.isPlotting === true) {
                        if (this.rgbElement.current.state.mouseIsPressed === false) {
                            await this.state.LRobj.drone_tt_led_set(
                                Number(this.rgbElement.current.state.slid1),
                                Number(this.rgbElement.current.state.slid2),
                                Number(this.rgbElement.current.state.slid3))
                        }
                    }
                    
                    if (this.state.isPlotting === true) {
                        await this.ldt_monitor()
                    }
                    //
                    //this.skip_count += 1
                    //if (this.skip_count >= this.skip_LIMIT) {
                        //this.skip_count = 0
                        //let monitor_state = await this.ldt_monitor()
                        //if (monitor_state === 0) {
                        //    return 0
                        //}
                    //}
                    
                    if (this.state.isPlotting === true) {
                        let timeoutID = setTimeout(this.updatePlot, this.state.updateRate);
                        this.setState( {updateID: timeoutID} );
                    }
                    return    
                }

            }

            let dataArrays = [];

            if (this.state.hardwareSelection === 'LocoIoT') {
                if (this.state.sensorSelection === 'Accelerometer') {
                    dataArrays = this.state.LRobj.get_data_array('Accelerometer');
                } else if (this.state.sensorSelection === 'Gyroscope') {
                    dataArrays = this.state.LRobj.get_data_array('Gyroscope');
                } else {
                    dataArrays = this.state.LRobj.get_data_array(this.state.LRobj.self[this.state.LRobj.options[this.state.sensorSelection].refer].value);
                }
            } else if (hSelectSendRefer.includes(this.state.hardwareSelection)) {
                dataArrays = this.state.LRobj.get_data_array(this.state.LRobj.self[this.state.LRobj.options[this.state.sensorSelection].refer].arrays);
            } else {
                dataArrays = this.state.LRobj.get_data_array(this.state.LRobj.self[this.state.LRobj.options[this.state.sensorSelection].refer].value);
            }
            

            let hasYsettings = false;
            let rangeTemp;
            let axisOffsets;
            if (this.state.LRobj.options[this.state.sensorSelection].hasOwnProperty('range')) {
                //dataArrays[i]
                rangeTemp = this.state.LRobj.options[this.state.sensorSelection].range;
                axisOffsets = this.state.LRobj.options[this.state.sensorSelection].offset;
                hasYsettings = true;
            }

            for (let i = 0; i < dataArrays.length; i++) {                
                
                let data_update;
                let layout;

                if (hasYsettings === true) {
                    
                    if (rangeTemp[i] === 'min') {

                        let minVal = Math.min.apply(Math, dataArrays[i]);
                        let maxVal = Math.max.apply(Math, dataArrays[i]);
                        
                        if (Math.abs(maxVal - minVal) < axisOffsets * 2) {
                            data_update = {
                                y: [dataArrays[i]],
                            }
                            // Setup Plot Layout
                            layout = {
                                yaxis: {title: this.state.LRobj.self[this.state.LRobj.options[this.state.sensorSelection].refer].ylabels[i], autorange: false, range: [minVal - axisOffsets, maxVal + axisOffsets]},
                            };
    
                        } else {
                            data_update = {
                                y: [dataArrays[i]],
                            }
                            layout = {
                                yaxis: {title: this.state.LRobj.self[this.state.LRobj.options[this.state.sensorSelection].refer].ylabels[i], autorange: true,},
                            };
                        }  
                    } else {
                        data_update = {
                            y: [dataArrays[i]],
                        }
                        layout = {
                            yaxis: {title: this.state.LRobj.self[this.state.LRobj.options[this.state.sensorSelection].refer].ylabels[i], range: this.state.LRobj.options[this.state.sensorSelection].fixed},
                        };
                    }
                } else {
                    data_update = {
                        y: [dataArrays[i]],
                    }
                }

                try {
                    window.Plotly.update(this[`charRef${i}`].current, data_update, layout);
                } catch (err) {

                }

            }
            
            if (this.state.isPlotting === true) {
                try {
                   const res = await this.getData();
                    if (this.state.hardwareSelection === 'LocoDroneT' && (this._ldtTelemetryPaused || generation !== this._ldtTelemetryGeneration || !this.state.isPlotting)) return;
                    if (res !== 0) {
                        let timeoutID = setTimeout(this.updatePlot, this.state.updateRate);
                        this.setState( {updateID: timeoutID} );
                    } else {
                        clearTimeout(this.state.updateID);
                        if ((this.hardwareSelection === 'LocoDroneT') || 
                            (this.hardwareSelection === 'LocoDroneTT')) {
                            this.state.LRobj.clearData()
                            clearTimeout(this.state.LRobj.get_vitals_timer_ID);
                        } 
                        if (this.state.hardwareSelection === 'LocoDroneTT') {
                            this.state.LRobj.clearLDTTimeouts()
                        }
                        this.setState( {isPlotting: false, plottingText: "Start Plotting", isConnected: false} );
                        this.state.LRobj.resetArrays();
                        setTimeout( this.changeConnect, 50);
                    }
                } catch {
                    if (this.state.hardwareSelection === 'LocoDroneT' && (this._ldtTelemetryPaused || generation !== this._ldtTelemetryGeneration || !this.state.isPlotting)) return;
                    // revert to disconnect state
                    clearTimeout(this.state.updateID);
                    if ((this.hardwareSelection === 'LocoDroneT') || 
                        (this.hardwareSelection === 'LocoDroneTT')) {
                        this.state.LRobj.clearData()
                        clearTimeout(this.state.LRobj.get_vitals_timer_ID);
                    } 
                    if (this.state.hardwareSelection === 'LocoDroneTT') {
                        this.state.LRobj.clearLDTTimeouts()
                    }
                    
                    this.setState( {isPlotting: false, plottingText: "Start Plotting", isConnected: false} );
                    this.state.LRobj.resetArrays();
                    setTimeout( this.changeConnect, 50);

                }
            }
        }
    };




    openDisplay = async () => {
        if (this.state.hardwareSelection === 'LocoDrone') {
            let tempObj = new LocoDrone();
            this.setState( {LRobj: tempObj} );
        } else if (this.state.hardwareSelection === 'LocoDroneT') {
            let tempObj = new LocoDroneT();
            this.setState( {LRobj: tempObj} );
        } else if (this.state.hardwareSelection === 'LocoDroneTT') {
            let tempObj = new LocoDroneTT();
            this.setState( {LRobj: tempObj} );
        } else if (this.state.hardwareSelection === 'LocoIoT') {
            let tempObj = new LocoIoT();
            this.setState( {LRobj: tempObj, isIoT: true} );
        } else if ((this.state.hardwareSelection === 'LocoArm') || (this.state.hardwareSelection === 'LocoArmS')) {
            let tempObj = new LocoArm();
            this.setState( {LRobj: tempObj} );
        } else if ((this.state.hardwareSelection === 'LocoArmM') || (this.state.hardwareSelection === 'LocoArmMS')) {
            let tempObj = new LocoArmM();
            this.setState( {LRobj: tempObj} );
        } else if (this.state.hardwareSelection === 'LocoWear') {
            let tempObj = new LocoWear();
            this.setState( {LRobj: tempObj} );
        } else if (this.state.hardwareSelection === 'LocoXtreme') {
            let tempObj = new LocoXtreme();
            this.setState( {LRobj: tempObj} );
        } else if (this.state.hardwareSelection === 'LocoScout') {
            bleDeviceLS.reset();
            this.setState( {LRobj: bleDeviceLS} );
        } 
        else if ((this.state.hardwareSelection + 'Obj') in window.shared) {
            let tempObj = window.shared[this.state.hardwareSelection + 'Obj'];
            this.setState( {LRobj: tempObj} );
        }
        setTimeout(this.changeSelect, 50);
        
    }

    changeSelect = () => {
        this.setState( {sensorSelection: this.state.LRobj.optionNames[0]} );
        this.setState( {selected: true} );
    }


    visLWEnd = (endType) => {
    }

    visLDEnd = () => {        
    }

    visLDPromptEnd = (event) => {

        this.visLDPromptElement.current.handleClose();
        this.visLDElement.current.handleOpen();
        
        setTimeout(this.state.LRobj.calibrate, 1000);
    }

    render() {

        // Referenced below for setting styles
        const { classes } = this.props;

        // For TopBar Route Highlight
        const currentPath = this.props.location.pathname;

        return (
            <div className={classes.root}    
            style={{ height: '100vh', maxHeight: '100vh', backgroundColor: 'white', overflow: 'hidden'}}>
                <CssBaseline />
                <Topbar currentPath={currentPath} />
                    {this.state.selected === false && (
                        <Grid container justifyContent="center" className={classes.gridSelect}>
                            <Grid item xs={12} md={12}>
                                <Card className={classes.cardCenter}>
                                    <Grid container justifyContent="center" alignItems="center">
                                        <Grid item>
                                            <DataUsageIcon className={classes.icon} color="primary" />
                                        </Grid>
                                        <Grid item>
                                            <CardContent>
                                                <Typography variant="h5" component="h2">
                                                    Data Visualization
                                                </Typography>
                                                <Typography variant="body2" component="p">
                                                    Choose an option and press select to continue.
                                                </Typography>
                                            </CardContent>
                                        </Grid>
                                        <Grid item>
                                            <FormControl
                                                variant="outlined"
                                                className={classes.formControlSelect}
                                            >
                                                <InputLabel id="hardware-select-label">Hardware</InputLabel>
                                                <Select
                                                    className={classes.select}
                                                    labelId="hardware-select-label"
                                                    label="Hardware"
                                                    name="hardwareSelection"
                                                    value={this.state.hardwareSelection}
                                                    onChange={this.handleChange}
                                                    aria-describedby="hardware-pn-helper-text"
                                                >
                                                    {this.context.AuthInstance.userAccess.map((val) => {
                                                        if (!this.context.AuthInstance.NON_LIST.includes(val)) {
                                                            return (
                                                                <MenuItem key={val} value={val}
                                                                    className={classes.menuItem}
                                                                >
                                                                    {val}
                                                                </MenuItem>
                                                            );
                                                        }
                                                    })}
                                                </Select>
                                            </FormControl>
                                        </Grid>
                                        <Grid item>
                                            <Button
                                                color="primary"
                                                variant="contained"
                                                className={classes.actionButton}
                                                onClick={this.openDisplay}
                                            >
                                                Select
                                            </Button>
                                        </Grid>
                                    </Grid>
                                </Card>
                            </Grid>
                        </Grid>
                    )}
                    {this.state.selected === true && (
                        <Grid
                            spacing = {1}
                            justifyContent="center"
                            container
                            className={classes.grid}
                        >
                            <Grid item xs={3}>
                                <FormControl
                                    variant="outlined"
                                    className={classes.formControl}
                                >
                                    <Select
                                        value={this.state.sensorSelection}
                                        onChange={this.handleChange}
                                        aria-describedby="sensor-pn-helper-text"
                                        disabled={this.state.isPlotting}
                                        input={
                                        <OutlinedInput
                                            labelWidth={this.state.labelWidth}
                                            name="sensorSelection"
                                        />
                                        }
                                    >
                                        {this.state.LRobj.optionNames.map((val) => {
                                            return (
                                                <MenuItem key={val} value={val}>
                                                    {val}
                                                </MenuItem>
                                            );
                                        })}                        
                                    </Select>
                                    <FormHelperText className={classes.inputHelperSelect} id="sensor-pn-helper-text">Data Type</FormHelperText>
                                </FormControl>
                                <FormControl
                                    variant="outlined"
                                    className={classes.formControl}
                                >
                                    <Select
                                        value={this.state.colorSelection}
                                        onChange={this.handleChange}
                                        aria-describedby="sensor-pn-helper-text"
                                        disabled={this.state.isPlotting}
                                        input={
                                        <OutlinedInput
                                            labelWidth={this.state.labelWidth}
                                            name="colorSelection"
                                        />
                                        }
                                    >
                                        {this.state.colorOptions.map((val) => {
                                            return (
                                                <MenuItem key={val} value={val}>
                                                    {val}
                                                </MenuItem>
                                            );
                                        })}                        
                                    </Select>
                                    <FormHelperText className={classes.inputHelperSelect} id="sensor-pn-helper-text">Plot Color</FormHelperText>
                                </FormControl>
                            </Grid>
                            <Grid item xs={3}>
                                <FormControl fullWidth className={classes.formControl}> 
                                    <Input className={classes.inputField}
                                        id="standard-adornment-pn"
                                        aria-describedby="standard-pn-helper-text"
                                        disabled={this.state.isPlotting}
                                        inputProps={{
                                            'aria-label': 'pn',
                                        }}
                                        onChange = {this.handleChangeBuffer}
                                        value = {this.state.bufferSize}
                                    />
                                    <FormHelperText className={classes.inputHelper} id="standard-pn-helper-text">Buffer Size (10-100)</FormHelperText>
                                </FormControl>
                            </Grid>
                            <Grid item xs={3}>
                                <FormControl
                                    variant="outlined"
                                    className={classes.formControl}
                                >
                                    <Button
                                        color="primary"
                                        variant="contained"
                                        className={classes.actionButton}
                                        onClick={this.handleConnect}
                                    >
                                        {this.state.connectText}
                                    </Button>     
                                </FormControl>  
                                <FormControl
                                    variant="outlined"
                                    className={classes.formControl}
                                >                         
                                    <Button
                                        color="primary"
                                        variant="contained"
                                        className={classes.actionButton}
                                        onClick={this.handleStartPlotting}
                                        disabled={!this.state.isConnected}
                                    >
                                        {this.state.plottingText}
                                    </Button>    
                                </FormControl>
                            </Grid>
                            <Grid item xs={3}>
                                <Button
                                    color="primary"
                                    variant="contained"
                                    className={classes.actionButton}
                                    onClick={this.handleBack}
                                >
                                    Back
                                </Button>   
                            </Grid>
                            {this.state.isIoT === true && this.state.isPlotting === false && (
                                <img src={this.state.LRobj.options[this.state.sensorSelection].img} 
                                    alt=""
                                    height='400px'></img>                                    
                            )}
                            <Grid item xs={12}></Grid>
                            {(((this.state.hardwareSelection === "LocoDroneT") || 
                                (this.state.hardwareSelection === "LocoDroneTT")) && 
                                (this.state.isConnected === true)) && (
                                <Grid item xs={12}>
                                    {this.state.message_str_1}
                                </Grid>
                            )}
                            {this.state.LRobj.options[this.state.sensorSelection].count === "matrix" && this.state.isPlotting === true && (
                                <LDTMatrix
                                    ref = {this.matrixElement}
                                />
                            )}
                            {this.state.LRobj.options[this.state.sensorSelection].count === "rgb" && this.state.isPlotting === true && (
                                <LDTRGB
                                    ref = {this.rgbElement}
                                />
                            )}
                            {this.state.LRobj.options[this.state.sensorSelection].count >= 1 && this.state.isPlotting === true && (
                            <Grid item xs={4}>
                                <Paper className={classes.paper}>
                                    <div ref={this.charRef0}></div>
                                </Paper>
                            </Grid>
                            )}
                            {this.state.LRobj.options[this.state.sensorSelection].count > 1 && this.state.isPlotting === true && (
                            <Grid item xs={4}>
                                <Paper className={classes.paper}>
                                    <div ref={this.charRef1}></div>
                                </Paper>
                            </Grid>
                            )}
                            {this.state.LRobj.options[this.state.sensorSelection].count > 2 && this.state.isPlotting === true && (
                            <Grid item xs={4}>
                                <Paper className={classes.paper}>
                                    <div ref={this.charRef2}></div>
                                </Paper>
                            </Grid>
                            )}
                        </Grid>
                    )}
                <DataVisLW 
                    ref={this.visLWElement}
                    onEnd={this.visLWEnd}
                />
                <DataVisLD
                    ref={this.visLDElement}
                    onEnd={this.visLDEnd}
                />
                <DataVisLDPrompt
                    ref={this.visLDPromptElement}
                    onClose={this.visLDPromptEnd}
                />
                <LXSettingsModal
                    ref={this.LXSelectionElement}
                    onClose={this.LXSelection}
                />
                <LDTSettingsModal
                    ref = {this.LDTSelectionElement}
                    onClose= {this.LDTSelection}
                />
                <GeneralMessage
                    ref = {this.LXScanMsgElement}
                    onClose = {this.openLXSelection}
                />
                <GeneralMessage
                    ref = {this.LDTScanMsgElement}
                    onClose = {this.handleLDTScanDrawerClose}
                />
                <GeneralMessage
                    ref = {this.LXConnMsgElement}
                    onClose = {() => void 0}
                />
                <GeneralMessage
                    ref = {this.LXNoConnMsgElement}
                    onClose = {() => void 0}
                />
                <GeneralMessage
                    ref = {this.LDTConnMsgElement}
                    onClose = {() => void 0}
                />
                <GeneralMessage
                    ref = {this.LDTNoConnMsgElement}
                    onClose = {() => void 0}
                />
                <GeneralMessage
                    ref = {this.MsgElement}
                    onClose = {() => void 0}
                />
                <ButtonsListModal
                    ref = {this.ButtonsListElem}
                    onClose = {this.ButtonsListSelection}
                />
                <LCInputsModal
                    ref = {this.LCInputsElement}
                    onClose = {this.LCConnect}
                />
            </div>
        );
    }

}


export default withRouter(withStyles(styles)(DataVis));

